import React from 'react';
import AssetWrapper, { AssetWrapperProps } from 'src/app/atoms/Asset/AssetWrapper';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { ColumnSpan } from 'src/app/atoms/Layout/Column.styles';
import { ColorModePropKeys } from 'src/app/styles/colors';
import { ImageContainer } from './ImageAndContent.styles';

export interface ImageAndContentProps {
  image: AssetWrapperProps;
  content: React.ReactNode;
  contentPosition?: 'left' | 'right';
  contentBackground?: ColorModePropKeys;
  imageBackground?: ColorModePropKeys;
  imageColumns?: ColumnSpan;
  contentColumns?: ColumnSpan;
}

const ImageAndContent = ({
  image,
  content,
  contentPosition = 'right',
  contentBackground,
  imageBackground,
  imageColumns = 6 as ColumnSpan,
  contentColumns = 6 as ColumnSpan,
}: ImageAndContentProps): JSX.Element => {
  const renderImageBlock = () => (
    <ImageContainer
      columns={imageColumns}
      columnsLg={12}
      justify='center'
      align='center'
      background={imageBackground}
    >
      <AssetWrapper {...image} />
    </ImageContainer>
  );

  const renderContentBlock = () => (
    <Stack
      columns={contentColumns}
      columnsLg={12}
      padding={[
        'spacing-none',
        contentPosition === 'right' ? 'spacing-none' : 'spacing-7xl',
        'spacing-none',
        contentPosition === 'left' ? 'spacing-none' : 'spacing-7xl',
      ]}
      paddingLg={['spacing-none', 'spacing-none', 'spacing-4xl']}
      justify='center'
      align='center'
      background={contentBackground}
    >
      {content}
    </Stack>
  );

  const renderContentFirst = () => (
    <Grid>
      {renderContentBlock()}
      {renderImageBlock()}
    </Grid>
  );

  const renderMobile = () => (
    <Grid showOn='lg'>
      {renderContentBlock()}
      {renderImageBlock()}
    </Grid>
  );

  const renderImageFirst = () => (
    <>
      <Grid hideOn='lg'>
        {renderImageBlock()}
        {renderContentBlock()}
      </Grid>
      {renderMobile()}
    </>
  );

  return (
    <Stack
      direction='column'
      align='center'
      justify='center'
    >
      {contentPosition === 'left' ? renderContentFirst() : renderImageFirst()}
    </Stack>
  );
};

export default ImageAndContent;
